import graphqlClient from "../../../apollo";

class IngredientProvider {

    findIngredient(id) {
        return graphqlClient.query({
            query: require('./gql/Ingredient/findIngredient.graphql'),
            variables: {id:id}
        })
    }

    fetchIngredient() {
        return graphqlClient.query({query: require('./gql/Ingredient/fetchIngredient.graphql')})
    }
    
    paginateIngredient(pageNumber, itemsPerPage, search = null, filters = null,  orderBy = null, orderDesc = false) {
        return graphqlClient.query({
            query: require('./gql/Ingredient/paginateIngredient.graphql'),
            variables: {pageNumber, itemsPerPage, search, filters, orderBy, orderDesc},
            fetchPolicy: "network-only"
        })
    }
    
    

    createIngredient(input) {
        return graphqlClient.mutate({
            mutation: require('./gql/Ingredient/createIngredient.graphql'),
            variables: {input}
        })
    }
    
    updateIngredient(id,input) {
        return graphqlClient.mutate({
            mutation: require('./gql/Ingredient/updateIngredient.graphql'),
            variables: {id, input}
        })
    }
    
     deleteIngredient(id) {
        return graphqlClient.mutate({
            mutation: require('./gql/Ingredient/deleteIngredient.graphql'),
            variables: {id}
        })
    }

}

export default new IngredientProvider()


